import React, { useState } from "react";
import "./Calendar.css";

function Calendar({ expenses, showACalendar }) {
  console.log(expenses);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "January",
    "February",
    "Marzo",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handlePrevMonth = () => {
    setSelectedDate((prevDate) => {
      return new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
    });
  };

  const handleNextMonth = () => {
    setSelectedDate((prevDate) => {
      return new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
    });
  };

  const monthName = months[selectedDate.getMonth()];
  const year = selectedDate.getFullYear();
  const daysInMonth = new Date(year, selectedDate.getMonth() + 1, 0).getDate();

  const monthDays = [];
  for (let i = 1; i <= daysInMonth; i++) {
    monthDays.push(i);
  }

  const firstDayOfMonth = new Date(year, selectedDate.getMonth(), 1).getDay();
  const emptyDays = [];
  for (let i = 0; i < firstDayOfMonth; i++) {
    emptyDays.push(i);
  }

  // Create an object to hold the expenses, grouped by day
  const expensesByDay = {};
  expenses.forEach((expense) => {
    const dayOfMonth = expense.dia;
    const month = expense.mes;
    if (month === months[selectedDate.getMonth()]) {
      if (!expensesByDay[dayOfMonth]) {
        expensesByDay[dayOfMonth] = [];
      }
      expensesByDay[dayOfMonth].push(expense);
    }
  });
  console.log(expensesByDay);
  return (
    <div className="calendar modal-content-calendar">
      <button className="closeCalendar" onClick={showACalendar}>
        X
      </button>
      <div className="calendar-header">
        <button className="button-calendar" onClick={handlePrevMonth}>
          Previous
        </button>{" "}
        <h2>
          {monthName} {year}
        </h2>
        <button className="button-calendar" onClick={handleNextMonth}>
          Next
        </button>
      </div>
      <div className="calendar-body">
        {weekdays.map((day) => (
          <div className="calendar-day weekday" key={day}>
            {day}
          </div>
        ))}
        {emptyDays.map((day, index) => (
          <div className="calendar-day-empty" key={index}></div>
        ))}
        {monthDays.map((day) => {
          const expensesForDay = expensesByDay[day];
          const backgroundColor = expensesForDay
            ? expensesForDay.length > 0
              ? "orange"
              : ""
            : "";
          return (
            <div
              className={`calendar-day${
                day === selectedDate.getDate() ? "" : ""
              }`}
              style={{ backgroundColor: backgroundColor }}
              key={day}
              onClick={() =>
                setSelectedDate(new Date(year, selectedDate.getMonth(), day))
              }
            >
              {day}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Calendar;
